import { MenuComponent } from './../../shared/components/menu/menu.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../shared/services/local-storage.service';

@Component({
  selector: 'app-main',
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(2000, style({ opacity: 1 })),
      ]),
    ]),
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  public userId: string | undefined;
  @Input() activeRoute = '';
  public menuIsOpen: boolean = false;
  @ViewChild(MenuComponent) child: MenuComponent;
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  openMenu() {
    document.getElementById('menu').classList.remove('hidden');
    document.getElementById('menu').classList.add('menu-container-open');
    console.log(document.getElementById('menu').classList);
    this.menuIsOpen = true;
  }

  closeMenu() {
    document.getElementById('menu').classList.add('menu-container-close');
    setTimeout(() => {
      document.getElementById('menu').classList.remove('menu-container-close');
      document.getElementById('menu').classList.add('hidden');
    }, 600);
    this.menuIsOpen = false;
  }

  selectCurrentRoute($route) {
    console.log('ROUTE', $route);
  }

  changeOfRoutes = () => {};

  // ALWAYS DISPLAY THE PAGE TO THE TOP
  onActivate(event) {
    window.scroll(0, 0);
  }
}
